import React from "react";
import { Card, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { NavButton } from "~/components/InternalLink";

const { Title, Text } = Typography;

export interface PricingPlan {
  title: string;
  price: string;
  description: string;
  features: string[];
  value: string;
  buttonText: string;
  highlight?: boolean;
  highlightLabel?: string;
}

interface PricingCardProps {
  plan: PricingPlan;
  returnUrl?: string;
}

function buildSignupUrl(planValue: string, returnUrl?: string): string {
  const params = new URLSearchParams({ plan: planValue });
  if (returnUrl) {
    params.set("returnUrl", returnUrl);
  }
  return `/signup?${params.toString()}`;
}

export const PricingCard: React.FC<PricingCardProps> = ({
  plan,
  returnUrl,
}) => {
  const signupUrl = buildSignupUrl(plan.value, returnUrl);

  return (
    <Card
      title={plan.title}
      bordered={true}
      hoverable
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderColor: plan.highlight ? "#1890ff" : "#f0f0f0",
        borderWidth: plan.highlight ? "2px" : "1px",
        position: "relative",
      }}
      headStyle={{
        textAlign: "center",
        fontSize: "1.5rem",
        backgroundColor: plan.highlight ? "#e6f7ff" : "transparent",
        color: plan.highlight ? "#1890ff" : "inherit",
      }}
      bodyStyle={{ flex: 1, display: "flex", flexDirection: "column" }}
    >
      {plan.highlight && plan.highlightLabel && (
        <div
          style={{
            position: "absolute",
            top: -12,
            left: "50%",
            transform: "translateX(-50%)",
            background: "#1890ff",
            color: "white",
            padding: "2px 12px",
            borderRadius: "10px",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: 1,
          }}
        >
          {plan.highlightLabel}
        </div>
      )}
      <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
        <Title level={3} style={{ margin: 0 }}>
          {plan.price}
        </Title>
        <Text type="secondary">{plan.description}</Text>
      </div>

      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: "0 0 2rem 0",
          flex: 1,
        }}
      >
        {plan.features.map((feature, index) => (
          <li
            key={index}
            style={{
              marginBottom: "10px",
              display: "flex",
              alignItems: "start",
            }}
          >
            <CheckOutlined
              style={{
                color: "#52c41a",
                marginRight: "10px",
                marginTop: "5px",
              }}
            />
            <Text>{feature}</Text>
          </li>
        ))}
      </ul>

      <NavButton
        to={signupUrl}
        type={plan.highlight ? "primary" : "default"}
        size="large"
        block
      >
        {plan.buttonText}
      </NavButton>
    </Card>
  );
};
